<template>
  <ss-modal
    v-show="isModalVisible"
    class="md"
    title="Title"
    intro="bounceIn"
    outro="bounceOut">
    <!-- HEADER -->
    <div slot="modal-header">
      Załączanie pliku
      <i class="close" @click="closeModal(false)"></i>
    </div>
    <!-- BODY -->
    <div slot="modal-body">
      <div class="form-field">
        <div
          v-if="fileIndex === null"
          class="file-selection">
          <div class="w-100">
            <p
              :class="{
                'file-selection-label my-auto form-control': true,
                'is-invalid' : errors.has('fileInput')
              }"
              @click.prevent="triggerFileInput">
              {{ label }}
            </p>
            <div class="invalid-feedback">
              {{ errors.first('fileInput') }}
            </div>
          </div>
          <input
            type="file"
            ref="fileInput"
            @change="onChange"
            v-validate="'required'"
            style="display: none;"
            name="fileInput" />
          <d-button
            @click.prevent="triggerFileInput"
            type="button"
            class="mb-auto">
            Wybierz plik
          </d-button>
        </div>
        <div v-else>
          Nazwa pliku: <strong>{{ label }}</strong>
        </div>
      </div>

      <div
        v-if="hasDescription"
        class="form-field mt-4">
        <ss-textarea
          v-model="description"
          name="description"
          label="Opis"
          placeholder="Opis..." />
      </div>
    </div>
    <!-- FOOTER -->
    <div slot="modal-footer">
      <d-button
        @click.prevent="closeModal(false)"
        theme="danger">
        <i class="material-icons">close</i> Zamknij
      </d-button>
      <d-button
        @click.prevent="validateForm"
        theme="success" class="ml-3">
        <i class="material-icons">save</i> Zapisz
      </d-button>
    </div>
  </ss-modal>
</template>

<script>
import SsModal from '@/components/common/SsModal';

export default {
  name: 'DiscountFormModal',
  components: {
    SsModal
  },
  data () {
    return {
      description: '',
      fileType: '',
      hasDescription: false,
      isModalVisible: false,
      label: 'Nie wybrano pliku',
      selectedFile: null,
      fileIndex: null
    }
  },
  methods: {
    showModal (fileType = '', hasDescription = false, file = null, fileIndex = null) {
      Vue.set(this, 'selectedFile', file);
      Vue.set(this, 'fileIndex', fileIndex);
      Vue.set(this, 'fileType', fileType);

      Vue.set(this, 'hasDescription', hasDescription);
      Vue.set(this, 'description', '');
      Vue.set(this, 'label', 'Nie wybrano pliku');
      if (file) {
        Vue.set(this, 'label', file.filename);

        if (file.description) {
          Vue.set(this, 'description', file.description);
        }
      }

      this.resetFormValidation();

      this.$nextTick(() => {
        this.isModalVisible = true;
      })
    },
    closeModal (isFileSave = false) {
      this.$validator.reset()
      .then(() => {
        this.isModalVisible = false;
        if (isFileSave) {
          if (this.fileIndex === null) {
            this.$emit('addFile', this.selectedFile, this.fileType, this.description);
            return;
          }
          this.$emit('updateFile', this.fileIndex, this.description);
        }
      })
    },
    validateForm () {
      this.$validator.validateAll().then((isValid) => {
        if (!isValid) {
          return;
        }

        this.closeModal(true);
      });
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    onChange (event) {
      let file = event.target.files[0];
      this.selectedFile = file;
      this.label = file ? file.name : 'Nie wybrano pliku';
    },
    resetFormValidation () {
      this.$validator.pause();
      this.$nextTick(() => {
        this.$validator.errors.clear()
        this.$validator.fields.items.forEach(field => field.reset())
        this.$validator.fields.items.forEach(field => this.errors.remove(field))
        this.$validator.resume()
      })
    }
  }
}
</script>

<style scoped lang="scss">
.file-selection {
  display: flex;

  .btn {
    flex-shrink: 0;
  }
}
</style>